var v = "5.7.11";
var fr = 29.9700012207031;
var ip = 0;
var op = 121.000004928431;
var w = 468;
var h = 468;
var nm = "documents nofade";
var ddd = 0;
var assets = [];
var layers = [
    {
        ddd: 0,
        ind: 2,
        ty: 4,
        nm: "line",
        parent: 4,
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    0,
                    -40.908,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [
                            [
                                0,
                                0
                            ],
                            [
                                0,
                                0
                            ]
                        ],
                        o: [
                            [
                                0,
                                0
                            ],
                            [
                                0,
                                0
                            ]
                        ],
                        v: [
                            [
                                -39.8,
                                0
                            ],
                            [
                                39.8,
                                0
                            ]
                        ],
                        c: false
                    },
                    ix: 2
                },
                nm: "Path 1",
                mn: "ADBE Vector Shape - Group",
                hd: false
            },
            {
                ty: "st",
                c: {
                    a: 0,
                    k: [
                        0.298039227724,
                        0.607843160629,
                        0.831372559071,
                        1
                    ],
                    ix: 3,
                    x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Strokes')('Color');"
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 19.167,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                bm: 0,
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
            },
            {
                ty: "tm",
                s: {
                    a: 0,
                    k: 0,
                    ix: 1
                },
                e: {
                    a: 1,
                    k: [
                        {
                            i: {
                                x: [
                                    0.24
                                ],
                                y: [
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.76
                                ],
                                y: [
                                    0
                                ]
                            },
                            t: 32,
                            s: [
                                0
                            ]
                        },
                        {
                            t: 41.0000016699642,
                            s: [
                                100
                            ]
                        }
                    ],
                    ix: 2
                },
                o: {
                    a: 0,
                    k: 0,
                    ix: 3
                },
                m: 1,
                ix: 3,
                nm: "Trim Paths 1",
                mn: "ADBE Vector Filter - Trim",
                hd: false
            }
        ],
        ip: 32.0000013033867,
        op: 932.000037961138,
        st: 32.0000013033867,
        bm: 0
    },
    {
        ddd: 0,
        ind: 3,
        ty: 4,
        nm: "line",
        parent: 4,
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    -13.803,
                    -6.974,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                    a: 0,
                    k: {
                        i: [
                            [
                                0,
                                0
                            ],
                            [
                                0,
                                0
                            ]
                        ],
                        o: [
                            [
                                0,
                                0
                            ],
                            [
                                0,
                                0
                            ]
                        ],
                        v: [
                            [
                                -25.997,
                                0
                            ],
                            [
                                25.997,
                                0
                            ]
                        ],
                        c: false
                    },
                    ix: 2
                },
                nm: "Path 1",
                mn: "ADBE Vector Shape - Group",
                hd: false
            },
            {
                ty: "tm",
                s: {
                    a: 0,
                    k: 0,
                    ix: 1
                },
                e: {
                    a: 1,
                    k: [
                        {
                            i: {
                                x: [
                                    0.24
                                ],
                                y: [
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.76
                                ],
                                y: [
                                    0
                                ]
                            },
                            t: 39,
                            s: [
                                0
                            ]
                        },
                        {
                            t: 46.0000018736184,
                            s: [
                                100
                            ]
                        }
                    ],
                    ix: 2
                },
                o: {
                    a: 0,
                    k: 0,
                    ix: 3
                },
                m: 1,
                ix: 2,
                nm: "Trim Paths 1",
                mn: "ADBE Vector Filter - Trim",
                hd: false
            },
            {
                ty: "st",
                c: {
                    a: 0,
                    k: [
                        0.298039227724,
                        0.607843160629,
                        0.831372559071,
                        1
                    ],
                    ix: 3,
                    x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Strokes')('Color');"
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 19.167,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                bm: 0,
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
            }
        ],
        ip: 39.0000015885026,
        op: 946.00003853137,
        st: 46.0000018736184,
        bm: 0
    },
    {
        ddd: 0,
        ind: 4,
        ty: 4,
        nm: "front doc",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                s: true,
                x: {
                    a: 0,
                    k: 217.29,
                    ix: 3
                },
                y: {
                    a: 0,
                    k: 248.489,
                    ix: 4
                }
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        hasMask: true,
        masksProperties: [
            {
                inv: false,
                mode: "a",
                pt: {
                    a: 0,
                    k: {
                        i: [
                            [
                                0,
                                0
                            ],
                            [
                                0,
                                127.026
                            ],
                            [
                                127.025,
                                0
                            ],
                            [
                                0,
                                -127.025
                            ],
                            [
                                -127.026,
                                0
                            ]
                        ],
                        o: [
                            [
                                127.025,
                                0
                            ],
                            [
                                0,
                                -127.025
                            ],
                            [
                                -127.026,
                                0
                            ],
                            [
                                0,
                                127.026
                            ],
                            [
                                0,
                                0
                            ]
                        ],
                        v: [
                            [
                                17.5,
                                215.5
                            ],
                            [
                                247.5,
                                -14.5
                            ],
                            [
                                17.5,
                                -244.5
                            ],
                            [
                                -212.5,
                                -14.5
                            ],
                            [
                                17.5,
                                215.5
                            ]
                        ],
                        c: true
                    },
                    ix: 1
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 3
                },
                x: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                nm: "Mask 1"
            }
        ],
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        -7.619,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        7.626
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        7.619,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        -7.626
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        7.619,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        -7.626
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        -7.619,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        7.626
                                    ]
                                ],
                                v: [
                                    [
                                        -55.642,
                                        89.614
                                    ],
                                    [
                                        55.642,
                                        89.614
                                    ],
                                    [
                                        69.445,
                                        75.812
                                    ],
                                    [
                                        69.445,
                                        -75.812
                                    ],
                                    [
                                        55.642,
                                        -89.614
                                    ],
                                    [
                                        -55.642,
                                        -89.614
                                    ],
                                    [
                                        -69.445,
                                        -75.812
                                    ],
                                    [
                                        -69.445,
                                        75.812
                                    ]
                                ],
                                c: true
                            },
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "st",
                        c: {
                            a: 0,
                            k: [
                                0.298039227724,
                                0.607843160629,
                                0.831372559071,
                                1
                            ],
                            ix: 3,
                            x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Strokes')('Color');"
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 4
                        },
                        w: {
                            a: 0,
                            k: 19.167,
                            ix: 5
                        },
                        lc: 2,
                        lj: 2,
                        bm: 0,
                        nm: "Stroke 1",
                        mn: "ADBE Vector Graphic - Stroke",
                        hd: false
                    },
                    {
                        ty: "fl",
                        c: {
                            a: 0,
                            k: [
                                0.937254901961,
                                0.96862745098,
                                1,
                                1
                            ],
                            ix: 4,
                            x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Fills')('Color');"
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 5
                        },
                        r: 1,
                        bm: 0,
                        nm: "Fill 1",
                        mn: "ADBE Vector Graphic - Fill",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 1,
                            k: [
                                {
                                    i: {
                                        x: 0.46,
                                        y: 0.883
                                    },
                                    o: {
                                        x: 0.711,
                                        y: 0
                                    },
                                    t: 19,
                                    s: [
                                        0,
                                        -350
                                    ],
                                    to: [
                                        0,
                                        51.212
                                    ],
                                    ti: [
                                        0,
                                        -62.949
                                    ]
                                },
                                {
                                    i: {
                                        x: 0.62,
                                        y: 1
                                    },
                                    o: {
                                        x: 0.289,
                                        y: 0.171
                                    },
                                    t: 30,
                                    s: [
                                        0,
                                        53.455
                                    ],
                                    to: [
                                        0,
                                        2.608
                                    ],
                                    ti: [
                                        0,
                                        -2.122
                                    ]
                                },
                                {
                                    t: 34.0000013848484,
                                    s: [
                                        0,
                                        0
                                    ],
                                    h: 1
                                }
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 3,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            }
        ],
        ip: 19.0000007738859,
        op: 919.000037431637,
        st: 19.0000007738859,
        bm: 0
    },
    {
        ddd: 0,
        ind: 5,
        ty: 4,
        nm: "back doc",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                s: true,
                x: {
                    a: 0,
                    k: 247.29,
                    ix: 3
                },
                y: {
                    a: 0,
                    k: 218.489,
                    ix: 4
                }
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        hasMask: true,
        masksProperties: [
            {
                inv: false,
                mode: "a",
                pt: {
                    a: 0,
                    k: {
                        i: [
                            [
                                0,
                                0
                            ],
                            [
                                0,
                                127.026
                            ],
                            [
                                127.025,
                                0
                            ],
                            [
                                0,
                                -127.025
                            ],
                            [
                                -127.026,
                                0
                            ]
                        ],
                        o: [
                            [
                                127.025,
                                0
                            ],
                            [
                                0,
                                -127.025
                            ],
                            [
                                -127.026,
                                0
                            ],
                            [
                                0,
                                127.026
                            ],
                            [
                                0,
                                0
                            ]
                        ],
                        v: [
                            [
                                -12.5,
                                245.5
                            ],
                            [
                                217.5,
                                15.5
                            ],
                            [
                                -12.5,
                                -214.5
                            ],
                            [
                                -242.5,
                                15.5
                            ],
                            [
                                -12.5,
                                245.5
                            ]
                        ],
                        c: true
                    },
                    ix: 1
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 3
                },
                x: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                nm: "Mask 1"
            }
        ],
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        -7.619,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        7.626
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        7.619,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        -7.626
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        7.619,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        -7.626
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        -7.619,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        7.626
                                    ]
                                ],
                                v: [
                                    [
                                        -55.642,
                                        89.614
                                    ],
                                    [
                                        55.642,
                                        89.614
                                    ],
                                    [
                                        69.445,
                                        75.812
                                    ],
                                    [
                                        69.445,
                                        -75.812
                                    ],
                                    [
                                        55.642,
                                        -89.614
                                    ],
                                    [
                                        -55.642,
                                        -89.614
                                    ],
                                    [
                                        -69.445,
                                        -75.812
                                    ],
                                    [
                                        -69.445,
                                        75.812
                                    ]
                                ],
                                c: true
                            },
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "st",
                        c: {
                            a: 0,
                            k: [
                                0.298039227724,
                                0.607843160629,
                                0.831372559071,
                                1
                            ],
                            ix: 3,
                            x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Strokes')('Color');"
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 4
                        },
                        w: {
                            a: 0,
                            k: 19.167,
                            ix: 5
                        },
                        lc: 2,
                        lj: 2,
                        bm: 0,
                        nm: "Stroke 1",
                        mn: "ADBE Vector Graphic - Stroke",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 1,
                            k: [
                                {
                                    i: {
                                        x: 0.46,
                                        y: 0.874
                                    },
                                    o: {
                                        x: 0.711,
                                        y: 0
                                    },
                                    t: 24,
                                    s: [
                                        0,
                                        -320
                                    ],
                                    to: [
                                        0,
                                        51.212
                                    ],
                                    ti: [
                                        0,
                                        -62.949
                                    ]
                                },
                                {
                                    i: {
                                        x: 0.62,
                                        y: 1
                                    },
                                    o: {
                                        x: 0.289,
                                        y: 0.171
                                    },
                                    t: 35,
                                    s: [
                                        0,
                                        53.455
                                    ],
                                    to: [
                                        0,
                                        2.608
                                    ],
                                    ti: [
                                        0,
                                        -2.122
                                    ]
                                },
                                {
                                    t: 39.0000015885026,
                                    s: [
                                        0,
                                        0
                                    ],
                                    h: 1
                                }
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            }
        ],
        ip: 24.00000097754,
        op: 924.000037635292,
        st: 24.00000097754,
        bm: 0
    },
    {
        ddd: 0,
        ind: 6,
        ty: 4,
        nm: "Trending",
        sr: 1,
        ks: {
            o: {
                a: 1,
                k: [
                    {
                        i: {
                            x: [
                                0.34
                            ],
                            y: [
                                1
                            ]
                        },
                        o: {
                            x: [
                                0.66
                            ],
                            y: [
                                0
                            ]
                        },
                        t: 0,
                        s: [
                            0
                        ]
                    },
                    {
                        t: 14.0000005702317,
                        s: [
                            100
                        ]
                    }
                ],
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    234,
                    234,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        127.026
                                    ],
                                    [
                                        127.025,
                                        0
                                    ],
                                    [
                                        0,
                                        -127.025
                                    ],
                                    [
                                        -127.026,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        127.025,
                                        0
                                    ],
                                    [
                                        0,
                                        -127.025
                                    ],
                                    [
                                        -127.026,
                                        0
                                    ],
                                    [
                                        0,
                                        127.026
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                v: [
                                    [
                                        0,
                                        230
                                    ],
                                    [
                                        230,
                                        0
                                    ],
                                    [
                                        0,
                                        -230
                                    ],
                                    [
                                        -230,
                                        0
                                    ],
                                    [
                                        0,
                                        230
                                    ]
                                ],
                                c: true
                            },
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "fl",
                        c: {
                            a: 0,
                            k: [
                                0.937254901961,
                                0.96862745098,
                                1,
                                1
                            ],
                            ix: 4,
                            x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Fills')('Color');"
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 5
                        },
                        r: 1,
                        bm: 0,
                        nm: "Fill 1",
                        mn: "ADBE Vector Graphic - Fill",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            }
        ],
        ip: 0,
        op: 900.000036657751,
        st: 0,
        bm: 0
    }
];
var markers = [];
var Documents = {
    v: v,
    fr: fr,
    ip: ip,
    op: op,
    w: w,
    h: h,
    nm: nm,
    ddd: ddd,
    assets: assets,
    layers: layers,
    markers: markers
};

export { assets, ddd, Documents as default, fr, h, ip, layers, markers, nm, op, v, w };
//# sourceMappingURL=Documents.json.es.js.map
